<template>
    <div id="app">
        <CommonHeader />
        <div class="container main-container">
            <router-view class="main-content" />
        </div>
    </div>
</template>

<script>
import CommonHeader from './components/CommonHeader.vue'

export default {
    name: 'App',
    components: {
        CommonHeader
    },
    created() {
        // 本地存储数据（解决页面刷新，数据丢失问题。注意：应使用ssionStorage[关闭浏览器即清除]，不要使用localStorage）

        // 在页面加载时读取sessionStorage里的状态信息
        if (sessionStorage.getItem("store")) {
            this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
        }

        // 在页面刷新时将vuex里的信息保存到sessionStorage里
        window.addEventListener("beforeunload", () => {
            sessionStorage.setItem("store", JSON.stringify(this.$store.state))
        })

        // 清除store缓存
        sessionStorage.removeItem("store")
        // console.info('APP created:',this.$store.state)
    },

}
</script>

<style lang="scss">
</style>